/*
 * @@Author: MuYang
 */
/*eslint-disable*/
import {assign, isUndefined, isEmpty, merge, cloneDeep} from 'lodash-es'
import {getDetailField} from '../../constants/fields'
import {COMPONENTS_NAMES} from '../../constants/componet-names'
import {LAYOUT_TYPE, FIELD_TYPE} from '../../constants'
import {insetButton} from '../store'
import {arrayToObj} from '../../../utils'
import {findObjectAuthCode} from '../../index'
import { SEQUENCE_CODE_KEY_MAP } from '../../constants'

// 默认值关联关系 页面类型
const relationList = [LAYOUT_TYPE.LAYOUT_TYPE_LIST_MASTER_RELATION_MORE, LAYOUT_TYPE.LAYOUT_TYPE_LIST_LOOKUP_RELATION_MORE, LAYOUT_TYPE.LAYOUT_TYPE_CREATE]

function getButtonType (location) {
  // 按钮区域类型分类
  const buttonTypeMap = {
    // 详情编辑头部操作区
    'section_detail_top': 'section_top',
    'section_create_top': 'section_top',
    'section_update_top': 'section_top',
    'section_detail_auxiliary': 'section_top',
    'section_create_auxiliary': 'section_top',
    'section_update_auxiliary': 'section_top',
    // 列表头部批量操作
    'section_list_batch': 'section_batch',
    // 列表行上操作
    'section_list_inline': 'section_inline',
    // 弹窗底部
    'section_bottom': 'section_bottom',
    'section_top': 'section_top',
    'section_batch': 'section_batch',
    'section_inline': 'section_inline'
  }
  return buttonTypeMap[location]
}

function getI18Name (field, i18Maps) {
  const result = {}
  const {i18nMap} = field
  for (let key in i18nMap) {
    result[key] = i18Maps[i18nMap[key]]
  }
  field.name = result['field_name'] || field.name
  field.placeholder = result['field_placeholder'] || field.placeholder
  field.tip = result['field_tip'] || field.tip
}

// 初始化带默认值的字段默认值
function initDefaultValue (defaultValue) {
  const {targetParamList, targetExpress} = defaultValue || {}
  if (!targetExpress) {
    return
  }
  const formulaFieldList = targetExpress.match(/\${(\S*)}/g)
  // 默认字段
  if (formulaFieldList) {
    defaultValue.formulaFieldList = formulaFieldList.map(item => {
      const targetParam = targetParamList.find(i => item.slice(2, -1) === i.paramSeqCode)
      let _params = {}
      if (targetParam.relationFieldType === FIELD_TYPE.LOOKUP_RELATION) {
        ([
          _params.relationFieldObjectApiName,
          _params.objectApiName,
          _params.fieldApiName,
          _params.relationFieldApiName,
          _params.relationFieldType,
          _params.fieldType
        ] = [
          targetParam.objectApiName,
          targetParam.relationFieldObjectApiName,
          targetParam.relationFieldApiName,
          targetParam.fieldApiName,
          targetParam.fieldType,
          targetParam.relationFieldType
        ])
      } else {
        _params = targetParam
      }
      return _params
    })
  } else {
    // 默认常量
    // TODO 常量默认值的数据 暂时写死 公式运算后 可优化掉
    defaultValue.formulaFieldList = [{
      objectApiName: '',
      fieldApiName: 'global__constant',
      fieldExpress: targetExpress,
      suffix: targetExpress,
      fieldClassification: 3
    }]
  }
  return defaultValue
}

// 格式化字段 后端data中field和默认field合并
function mergeField (fields, _fields = {}, i18Maps, {innerFields, info}) {
  // SEQUENCE_CODE_KEY_MAP
  const fieldMap = {}
  const _codeApiNameRelation = {}
  const _innerFields = (innerFields || []).map(v => v?.[SEQUENCE_CODE_KEY_MAP.TARGET_SEQ_CODE])
  let mainField = {}
  fields.forEach(field => {
    // dField 默认, field后端  _fields业务
    const dField = getDetailField(COMPONENTS_NAMES[field.type])
    // 数据合并 保持引用地址相同以field为合并基础
    const _field = assign(dField, field)
    const apiName = field[SEQUENCE_CODE_KEY_MAP.APINAME]
    fieldMap[apiName] = assign(
      field,
      _field,
      _fields[apiName],
      {
        __innerField: _innerFields.includes(field[SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE])
      }
    )
    _codeApiNameRelation[field[SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE]] = apiName
    getI18Name(field, i18Maps)
    // 提取主属性
    if (field.mainField) {
      mainField = fieldMap[field.apiName]
    }
    // 根据页面类型初始化默认值 (当前map为全量字段, 这里会把内置字段相关的默认值也会初始化)
    fieldMap[apiName].defaultValue = relationList.includes(info.type) && initDefaultValue(fieldMap[apiName]?.defaultValue)
  })
  return {
    fieldMap,
    mainField,
    _codeApiNameRelation
  }
}

// 获取i18
function getI18Info (pageInfo, i18Maps) {
  const i18nMap = pageInfo?.i18nMap
  if (i18nMap) {
    pageInfo.name = i18Maps[i18nMap['page_name']] || pageInfo.name
    pageInfo.title = i18Maps[i18nMap['title_name']] || pageInfo.title
  }
}

// 处理按钮
function mergeButtons (config, {pageAuthMap, i18Maps = {}, ...params}) {
  // businessButtons 业务
  const {buttons = [], buttonList, businessButtons = {}, btnsEvent = {}, buttonRules = []} = config
  // TODO 后面有删除业务按钮业务
  const _businessButtons = cloneDeep(businessButtons)
  const buttonMap = arrayToObj(buttonList, SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE)
  const buttonMerge = (item) => {
    // todo 判断权限  permissionPointApiName为空或者 pageAuthMap中有当前操作权
    // 不控权按钮(controlAuth = 0) 不走权限
    const objectApiName = params._objectApiName || params.objectApiName
    const _button = buttonMap?.[item[SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE]] || {}
    const _code = _button[SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE] || _button.apiName
    if (
      _button?.controlAuth === 0 ||
      _button?.permissionPointApiName === '' ||
      findObjectAuthCode(objectApiName, _button?.permissionPointApiName)
    ) {
      const buttonType = buttonMap[item[SEQUENCE_CODE_KEY_MAP.SEQUENCE_CODE]]?.buttonType
      // 合并业务按钮
      merge(item, _button, btnsEvent[buttonType], btnsEvent[_button.apiName], _businessButtons[_button.apiName], _businessButtons[_button.apiName]?.props)
      item.name = i18Maps[item.i18nMap?.['button_show_name']] || item.showName || _businessButtons?.[_button.apiName]?.props?.name || i18Maps[item.i18nMap?.['button_name']] || item.name
      item.__params = params
      item._rules = buttonRules.find(v => v.objectApiName === objectApiName && v.elementSeqCode === _code)
      insetButton(params._id, item, params.objectApiName, _code)
      return item
    }
  }
  const targetDefault = section => {
    if (isUndefined(target[getButtonType(section)])) {
      target[getButtonType(section)] = []
    }
  }
  const target = {}
  let button
  for (let i = 0; i < buttons.length; i++) {
    button = buttons[i]
    targetDefault(button.location)
    // 按钮逻辑处理
    button.buttons.forEach(item => {
      if (item.type === 'button_group') {
        item.__params = params
        item.info.name = i18Maps[item?.info?.i18nMap?.['button_group_name']] || item.info.name
        item.buttonList = item.elementLinks.map(btnName => buttonMerge(buttonMap[btnName])).filter(v => v)
        if (item.buttonList.length > 0) {
          target[getButtonType(button.location)].push(merge(item, item.info, _businessButtons[item.info?.apiName], _businessButtons[item.info?.apiName]?.props))
        }
        return
      }
      let btn = buttonMerge(item)
      btn && target[getButtonType(button.location)].push(btn)
    })
  }
  // 业务不是空对象追加数据
  if (!isEmpty(_businessButtons)) {
    for (let btnKey in _businessButtons) {
      const btn = _businessButtons[btnKey]
      const {section, position} = btn
      if (!getButtonType(section)) {
        continue
      }
      targetDefault(section)

      const _btn = assign({}, buttonMerge(btn), btn.props)
      const buttonList = target[getButtonType(section)]
      const idx = buttonList.findIndex(v => v.apiName === position)
      idx >= 0
        ? buttonList.splice(idx, 0, _btn)
        : buttonList.push(_btn)
    }
  }
  console.log(target, 'buttonMap')
  return target
}

// 合并配置
export default function mergeOptions ({data, page}, {config = {}, btnsEvent = {}, layoutApiName, _objectApiName, objectApiName, app, _id, i18Maps = {}}) {
  if (isUndefined(data)) {
    return {}
  }
  const {layout: pageLayout} = page
  const {info, fields, buttons: buttonList} = data
  // 合并info
  assign(info, pageLayout?.info)
  // 获取当前对象对应国际化数据
  // const i18Maps = getI18(_objectApiName || objectApiName) || {}
  // info
  getI18Info(info, i18Maps)

  const {buttonLocations, innerFields} = pageLayout
  const {fieldMap = {}, mainField, _codeApiNameRelation} = (fields && fields.length > 0) ? mergeField(fields, config.fields, i18Maps, {innerFields, info}) : {}
  const buttonMap = (buttonLocations && buttonLocations.length > 0) ? mergeButtons({
    buttons: buttonLocations,
    buttonList,
    btnsEvent,
    businessButtons: config.buttons,
    buttonRules: data?.rule?.buttonShowRuleList
  }, {i18Maps, layoutApiName, _objectApiName, objectApiName, app, _id}) : {}

  // 列分组
  let integrationConfig = {}
  if (pageLayout.data) {
    const {integrationGroupConfig, integrationGroups: _integrationGroups}  = pageLayout.data || {}
    if (integrationGroupConfig.grouping) {
      integrationConfig = {
        integrationGroups: _integrationGroups,
        ...integrationGroupConfig
      }
    }
  }

  return {
    i18Maps,
    info,
    fieldMap,
    buttonMap,
    mainField,
    integrationConfig,
    _codeApiNameRelation
  }
}
